import { Navigate } from 'react-router-dom';
import { clearLogout } from 'utils/auth/authUtils';

const Logout = () => {
  clearLogout();
  return (
    <Navigate to={"/login"} />
  )
}

export default Logout;